import React, { useState, useCallback, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Input } from 'antd';

import { AuthHeader, AuthFooter } from 'components';

import { alertMessage } from 'utils/utils';

import { loginUser } from '_actions/UserAction';

import { RootState } from '_reducers';

import * as ROUTES from 'constants/routes';
import AUTH from 'constants/auth';

import { StyledUserAdminLogin } from './style';

import logo from 'assets/images/admin/logo_mxcampus.png';

function Login(props: { history: string[] }) {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [userid, setUserid] = useState('');
  const [password, setpassword] = useState('');
  const loginUserCallback = useCallback(
    async (body: any) => dispatch(await loginUser(body)),
    [dispatch]
  );
  const { userData, loginStatus } = useSelector((state: RootState) => state.userReducer);

  const onUseridHandler = (event: { currentTarget: { value: React.SetStateAction<string> } }) => {
    setUserid(event.currentTarget.value);
  };

  const onPasswordHandler = (event: { currentTarget: { value: React.SetStateAction<string> } }) => {
    setpassword(event.currentTarget.value);
  };

  const onSubmitHandler = (event: { preventDefault: () => void }) => {
    event.preventDefault();

    let body = {
      userid: userid,
      password: password,
    };

    loginUserCallback(body).then((response: any) => {
      if (response.payload.loginStatus) {
        if (response.payload.userData.grade >= AUTH.indexOf('조교')) {
          navigate(ROUTES.USER_USERLIST_F);
        } else if (response.payload.userData.grade <= AUTH.indexOf('서브관리자')) {
          navigate(ROUTES.USER_USERLIST_F);
        } else {
          alertMessage('관리자에게 문의하세요.');
        }
      }
    });
  };
  useEffect(() => {
    if (loginStatus && userData.grade >= AUTH.indexOf('조교')) {
      navigate(ROUTES.USER_USERLIST_F);
    } else if (loginStatus && userData.grade <= AUTH.indexOf('서브관리자')) {
      navigate(ROUTES.USER_USERLIST_F);
    }
  }, [userData]);
  return (
    <StyledUserAdminLogin>
      <AuthHeader />
      <div className="login-wrapper">
        <div>
          <img src={logo} alt="" />
          <form onSubmit={onSubmitHandler}>
            <Input type="text" value={userid} placeholder="아이디" onChange={onUseridHandler} />
            <Input
              type="password"
              value={password}
              placeholder="비밀번호"
              onChange={onPasswordHandler}
            />
            <br />
            <Button type="primary" htmlType="submit">
              로그인
            </Button>
          </form>
        </div>
      </div>
      <AuthFooter />
    </StyledUserAdminLogin>
  );
}

export default Login;
